import {
  getSiteSupportedLanguages,
  getTldLanguageInfo,
  getDataCenterIdFromCurrentUrl,
  getDataCenterById,
  getSubdomainFromLanguageCodeAndDataCenter,
  getDefaultSubdomainForDataCenter
} from '@sm/locale';

const getFooterLanguageList = (url, tld) => {
  const languages = getSiteSupportedLanguages();
  const languageInfo = getTldLanguageInfo(tld);

  if (!url) {
    return [];
  }

  return languages.map(language => {
    const dataCenterId = getDataCenterIdFromCurrentUrl(url);

    const dataCenter = getDataCenterById(dataCenterId);
    let subdomain = getSubdomainFromLanguageCodeAndDataCenter(
      language.code,
      dataCenterId
    );
    let langTld = 'com';

    const primaryCCTldExistsForLanguage = language.tld !== 'com';
    const notOnCCTldCurrenty = ['com', 'net'].includes(tld);
    const languageSupportedByCurrentCCTld = languageInfo.supportedLanguages.includes(
      language.code
    );

    if (
      primaryCCTldExistsForLanguage &&
      dataCenter.CCTldSupport &&
      (notOnCCTldCurrenty || !languageSupportedByCurrentCCTld)
    ) {
      subdomain = getDefaultSubdomainForDataCenter(dataCenterId);
      langTld = language.tld;
    } else if (languageSupportedByCurrentCCTld && dataCenter.CCTldSupport) {
      langTld = tld;
    }

    return {
      name: language.name,
      subdomain,
      tld: langTld,
      displayName: language.displayName
    };
  });
};

export default getFooterLanguageList;
